import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import InputComponent from "../../../components/input";
import { UsersManagersService } from "../../../services/users";
import { ToastErro } from "../../../components/toast";
import TableComponent from "../../../components/table";
import { IUser } from "../../../types";
import { useNavigate } from "react-router-dom";

const UsersManagersPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [users, setUsers] = useState<any>([]);

    // variaveis de pesquisa
    const [name, setName] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar usuários
    const getUsers = async () => {

        setLoading(true);

        await UsersManagersService(name, page).then(resp => {
            setUsers(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);        
        });
        
        setLoading(false);

    }
    // função para pesquisar usuários

    useEffect(() => {
        getUsers();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Usuários Administrativos"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Nome"
                                col={8}
                                defaultValue={name}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                size={"small"}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getUsers()}>Pesquisar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Usuários Administrativos"
                        columns={['ID', 'Nome', 'Usuário', 'E-mail', 'Informações']}
                        loading={loading}
                        page={page}
                        last_page={users?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            users?.data?.map((u: IUser) => {
                                return (
                                    <tr key={u.id}>
                                        <td className="px-4">{u.id}</td>
                                        <td className="px-4">{u.name}</td>
                                        <td className="px-4">{u.username}</td>
                                        <td className="px-4">{u.email}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" onClick={() => navigate(`/users/managers/${u.id}`)}><i className="material-icons">info</i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default UsersManagersPage;